import React from 'react';
export const CFIconArrowCornerUpLeft = {
    alias: 'arrow-corner-up-left',
    defaultTitle: 'Arrow Corner Up Left',
    source: ({ Path }) => (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'M16 10H7.081l2.7-3.375a1 1 0 0 0-1.562-1.25l-4 5a1.001 1.001 0 0 0 0 1.25l4 5a.998.998 0 0 0 1.406.156 1 1 0 0 0 .156-1.406L7.081 12H16c.551 0 1 .449 1 1v5a1 1 0 0 0 2 0v-5c0-1.654-1.346-3-3-3Z' }))),
};
